module.exports = __webpack_public_path__ + "img/熊貓-素材.020deddd.svg";